/**
 * @fileoverview Como o cliente é chamado nas mensagens. A triagem pode montar o
 * nome do contato com dados para a equipe ("BR827372 Maria Souza", "Maria
 * Souza (SP)"), e o cliente não pode recebê-los como se fossem o nome dele.
 * Mesma regra do backend (helpers/customerFacingName.ts): com o nome como a
 * triagem montou, o nome limpo gravado junto (plainName); editado à mão
 * mantendo o que a triagem pôs antes e depois do nome, o que está no meio; de
 * outro jeito, ou de antes da regra, o nome sem o número da OS na frente.
 */

import { stripWorkOrderPrefix } from "./workOrderNamePrefix";

const squash = (text) => text.replace(/\s+/g, " ");

/** O nome editado sem o que a triagem pôs antes e depois do nome, se isso continua lá; senão, null. */
const editedName = (name, generated, plain) => {
  const at = generated.indexOf(plain);
  if (at < 0) return null;
  const before = squash(generated.slice(0, at)).toLowerCase();
  const after = squash(generated.slice(at + plain.length)).toLowerCase();
  if (!before && !after) return null;
  const edited = squash(name).trim();
  const lower = edited.toLowerCase();
  if (before.length + after.length >= edited.length || !lower.startsWith(before) || !lower.endsWith(after)) return null;
  const middle = edited.slice(before.length, edited.length - after.length).trim();
  return /\p{L}/u.test(middle) ? middle : null;
};

/** O nome com que o cliente é chamado; sem nome, "". */
export const customerFacingName = (contact) => {
  const name = contact?.name ?? "";
  const generated = contact?.generatedName;
  if (generated && name === generated) return (contact.plainName || "").trim();
  const plain = (contact?.plainName || "").trim();
  return (generated && plain && editedName(name, generated, plain)) || stripWorkOrderPrefix(name);
};
